module.exports = __webpack_public_path__ + "product-offers.svg?70ac3d0d2b0bdef8a43d82b61590d8c0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product-offers.svg
// module id = 312
// module chunks = 2